export const en = {
    abortion: 'Services related to pregnancy termination',
    'abortion-long-text': 'Contraindications apply. Consult your doctor. May cause possible adverse side effects.',
    acids: 'Acids, gases',
    'ad-image-babyfood': 'Make sure the graphic ad meets the requirements for advertising baby food',
    'ad-image-bad-quality': 'Please make sure that the uploaded image is high quality and clear',
    'ad-image-bad-text': 'Please make sure that the text in your image ad can be read in full',
    'ad-image-distance': 'Make sure that image ad contains seller data',
    'ad-image-finance':
        'Make sure the image ad contains enough information about the service provider and the source of information',
    'ad-image-house-cooperative': 'Make sure the graphic ad contains information about the housing savings cooperative',
    'ad-image-interface-element': 'Make sure that the image ad does not contain elements of a graphical user interface',
    'ad-image-lottery': 'Make sure the graphic ad contains the necessary information about the event',
    'ad-image-medicine': 'Please make sure that your image ad is accompanied by the necessary warning',
    'ad-image-nasty': 'Change the image of the image ad',
    'ad-image-no-border': 'Make sure that the image ad has visible boundaries',
    'ad-image-no-source': 'Make sure that the image ad indicates the source of information',
    'ad-image-share-building': 'Shared-equity construction',
    'ad-image-smi': 'Make sure the graphic ad contains the mass media content category',
    alcohol: 'Alcohol products',
    'alcohol-long-text': 'Enjoy in moderation.',
    'audio-requirements': 'Make sure that the audio meets the requirements',
    'baby_food-long-text': 'Consult an expert. For feeding children from {text} months old',
    banks: 'Banking services',
    'binary-options': 'Binary options',
    blacklist: 'Make sure that the phone number indicated on the vCard is correct',
    bookmaker: 'Sports betting',
    'car-numbers': 'Duplicate vehicle license plates',
    charity: 'Charitable foundations',
    'contact-info': 'Remove contact information from the ad text',
    'contact-info-callout': 'Contacts in text',
    copyright: 'Please present a letter of guarantee from the payer',
    'credit-consumer-cooperative': 'Credit unions',
    cryptocurrency: 'Cryptocurrency',
    detective: 'Detective services',
    'detective-equipment': 'Tracking devices',
    'dhref-requirements': 'Make sure that the display link corresponds to Yandex requirements',
    dietarysuppl: 'Nutritional supplements',
    'dietarysuppl-long-text': 'This is not a drug',
    distance_sales: 'Remote sale of goods',
    drugs: 'Narcotic substances and prescription drugs',
    'electronic-osago': 'Electronic third-party liability policies',
    errors: "Make sure that the text doesn't contain typos and the template is being used correctly",
    'errors-callout': 'Mistakes in text',
    'errors-ql': 'Make sure that the sitelink titles do not contain typos',
    'errors-vcard':
        'Make sure that the detailed description of the product or service in the vCard does not contain typos',
    explosions: 'Pyrotechnics',
    'false-info': 'Remove comparative or superlative adjectives from the vCard',
    'false-info-callout': 'False information in text',
    'false-info-vcard': 'Remove comparative or superlative adjectives from the vCard',
    'foreign-trade': 'Customs commodity code analysis',
    forex: 'Forex dealer',
    'forex-broker': 'Forex broker',
    gamble: 'Gambling',
    'html5-babyfood': 'baby food',
    'html5-bad-quality': 'Poor quality',
    'html5-bad-text': 'Unreadable text',
    'html5-finance': 'Finance',
    'html5-funds': 'Funds',
    'html5-house-cooperative': 'Cooperative',
    'html5-hrefs-errors': 'Make sure that the banner link is correct',
    'html5-illness': 'Illness',
    'html5-interface-element': 'Interface elements',
    'html5-lottery': 'Promotional events and lotteries',
    'html5-medicine': 'medicine',
    'html5-nasty': 'Unpleasant image',
    'html5-no-border': 'No borders',
    'html5-no-source': 'No source',
    'html5-russian-law': 'According to Russian law',
    'html5-securities': 'Securities',
    'html5-share-building': 'Shared-equity construction',
    'html5-smi': 'Protection of children',
    'html5-spam': 'NDA. Point 15',
    'illegal-diet': 'Dietary supplements indicated as a medical treatment',
    insurance: 'Insurance services',
    'invalid-contacts': 'Make sure that the contact information in the vCard is entered correctly',
    'invalid-url': 'Check site accessibility',
    'invalid-url-ql': "Check the accessibility of the sitelinks' landing pages",
    'irrelevant-image': "Make sure that the image matches the ad's subject",
    'irrelevant-keywords': 'Add or adjust keywords',
    'irrelevant-mobile-content':
        'Description of app in text or subject of ad does not match the app description in the store.',
    'irrelevant-site-link-description': 'The sitelink description does not match the ad text.',
    jewelry: 'Jewelry',
    'kazakh-law': 'Please make sure that advertising your products and services is permitted under Kazakh law',
    law: 'Legal services, audit',
    'license-required': 'Provide supporting documents for the advertised product or service',
    'license-required-dhref': 'Provide supporting documents for the advertised product or service',
    'license-required-ql': 'Submit supporting documents for the advertised product or service',
    'license-required-vcard': 'Submit supporting documents for the advertised product or service',
    loan: 'Loans',
    lottery: 'Lotteries and promotional activities',
    magic: 'Esotericism and magic',
    'maternity-capital': 'Loans based on maternity capital',
    'med-equipment': 'Medical appliances and devices',
    'med-services': 'Medical services',
    'med_equipment-long-text': 'There are contraindications. Consult a doctor',
    'med_services-long-text': 'There are contraindications. Consult a doctor',
    mediation: 'Mediation services',
    'medicine-long-text': 'There are contraindications. Consult a doctor',
    mfi: 'Microfinance organizations',
    'news-requirements': 'Make sure that the ad text refers to an information resource',
    'not-medicine': 'Books, videos, websites on medicine and treatment',
    notary: 'Notary services',
    optics: 'Optics',
    'other-reasons': 'Other reasons',
    pawnshop: 'Pawn shops',
    payment: 'Payment systems and money transfers',
    pharmacy: 'Pharmacies and medicine',
    'pharmacy-long-text': 'There are contraindications. Consult a doctor',
    'phone-do-not-answer': 'Make sure that the phone number on the vCard is working',
    politics: 'Political advertising cannot be placed via Yandex.Direct',
    'poor-image': 'Upload a high-resolution image to the interface',
    'popular-medicine': 'Folk medicine, healing',
    'project_declaration-long-text': 'Project declaration on advertised site',
    pseudoweapon: 'Weapons and products similar in construction to weapons',
    'pseudoweapon-long-text': "Item's design bears resemblance to weapons",
    psychology: 'Psychology',
    'ql-requirements': "Make sure the sitelinks' landing pages meet Yandex requirements",
    realtor: 'Realty',
    'russian-law':
        'Please make sure that advertising your products and services is permitted by the current legislation',
    'russian-law-callout':
        'Please make sure that advertising your products and services is permitted by the current legislation',
    'russian-law-dhref': 'Advertising materials do not comply with current legislation',
    'russian-law-image': 'Please make sure that the image does not contravene current legislation',
    'russian-law-ql': 'Please make sure that the sitelink titles do not contravene current legislation',
    'russian-law-vcard':
        'Make sure that the detailed description of your product or service in the vCard follows current legislation',
    'site-requirements': "Make sure that the site meets Yandex's requirements",
    spam: 'Ads cannot be placed on Yandex.Direct',
    'sports-nutrition': 'Sports nutrition',
    study: 'Work and education abroad',
    tattoo: 'Tattoos and piercings',
    'tech-inspection': 'Technical inspection',
    telemed: 'Online medical services',
    tm: 'Submit original guarantee letter',
    'tm-dhref': 'Submit original guarantee letter',
    tobacco: 'Сигареты, табак и аксессуары',
    transport: 'Passenger transport',
    'transport-adv': 'Advertising on vehicles',
    'turbolanding-requirements': 'Turbo page requirements',
    'turbolanding-requirements-slink': 'Turbo page requirements',
    'url-to-other-domain': 'Check sitelink addresses',
    veterinary: 'Veterinary services',
    'video-babyfood': 'Make sure the video meets the requirements for advertising baby food',
    'video-distance-sales': 'Make sure that the video contains seller data',
    'video-finance': 'Make sure the video contains enough information about the service provider',
    'video-house-cooperative': 'Make sure the video contains information about the housing savings cooperative',
    'video-lottery': 'Make sure the video contains the necessary information about the event',
    'video-medicine': 'Make sure that the video contains the required warnings',
    'video-requirements': 'Make sure that the video meets the requirements',
    'video-share-building': 'Make sure that the video contains information about shared-equity construction',
    'video-smi': 'Make sure that the age category is indicated in the video',
    weapons: 'Weapons',
    'yandex-policy': "Make sure that your ad materials match Yandex's ad policies",
    'yandex-policy-auto': 'Advertising this good/service is prohibited',
    'yandex-policy-callout': 'Yandex policy',
    'yandex-policy-image': "Make sure that the image meets Yandex's ad policies",
    'yandex-policy-vcard':
        'Make sure that the detailed description of your object of advertising (good or service) in the vCard meets the Yandex advertising policy'
};
